import React from 'react';

import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';

import { routes } from 'lane-shared/config';

import { Button } from 'components/general';

import { CategoriesTable } from '../categories/CategoriesTable';

import styles from '../styles.scss';

type Props = {
  formRoute?: string;
  canManage?: boolean;
};

export function CategoriesTab({ formRoute, canManage }: Props) {
  const { t } = useTranslation();
  const { id }: { id: string } = useParams();
  const history = useHistory();

  const handleCreateCategory = () => {
    history.push(
      formRoute ?? routes.channelAdminCreateCategoryForm.replace(':id', id)
    );
  };

  return (
    <>
      <div className={styles.heading}>
        {canManage && (
          <Button
            testId="newCategory"
            variant="contained"
            onClick={handleCreateCategory}
          >
            {t('abp.productsServices.categories.button')}
          </Button>
        )}
      </div>
      <CategoriesTable />
    </>
  );
}
